import { combineReducers } from "redux";
import showSideBarReducer from "./reducers/admin/showSideBarReducer";
import userReducer from "./reducers/auth/authReducer";
import changePasswordReducer from "./reducers/auth/changePassReducer";
import changePassModalReducer from "./reducers/auth/changePassModalReducer";
import editProfileModalReducer from "./reducers/auth/editProfileModalReducer";
import editProfileReducer from "./reducers/auth/editProfileReducer";
import forgotPasswordReducer from "./reducers/auth/forgotPassReducer";
import newPasswordReducer from "./reducers/auth/newPassReducer";
import userListingReducer from "./reducers/admin/userLisitingReducer";
import dealerListingReducer from "./reducers/admin/dealerLisitingReducer";
import userDetailsReducer from "./reducers/admin/userDetailsReducer";
import { categoryModalReducer } from "./../features/category/redux/categoryModalReducer"
import categoryReducer from "./../features/category/redux/categoryReducer"
import attributeModalReducer from "./../features/category/redux/attributeModalReducer"
import attributeReducer from "./../features/category/redux/attributeReducer"
import planModelReducer from "./../features/plans/redux/plamModalReducer"
import planReducer from "./../features/plans/redux/planReducer"

import tierModelReducer from "./../features/tiers/redux/tierModalReducer"
import tierReducer from "./../features/tiers/redux/tierReducer"

import bankReducer from "./../features/bank/redux/bankReducer"
import bankModalReducer from "./../features/bank/redux/bankModalReducer"

import vehiclesModelReducer from "./../features/vehicles/redux/vehiclesModalReducer"
import vehiclesReducer from "./../features/vehicles/redux/vehiclesReducer"

import suspiciousModelReducer from "./../features/suspisious-activity/redux/suspisiousModalReducer"
import suspiciousReducer from "./../features/suspisious-activity/redux/suspisiousReducer"



import financeModelReducer from "./../features/finance/redux/financeModalReducer"
import financeReducer from "./../features/finance/redux/financeReducer"

import settingsModelReducer from "./../features/settings/redux/settingsModalReducer"
import settingsReducer from "./../features/settings/redux/settingsReducer"
import makeModelReducer from "./../features/make/redux/makeModalReducer"
import makeReducer from "./../features/make/redux/makeReducer"
import blogModelReducer from "./../features/blog/redux/blogModalReducer"
import blogReducer from "./../features/blog/redux/blogReducer"

import articleModalReducer from "./../features/artical/redux/articleModalReducer"
import articleReducer from "./../features/artical/redux/articleReducer"

import faqsModalReducer from "./../features/faqs/redux/faqsModalReducer"
import faqsReducer from "./../features/faqs/redux/faqsReducer"
import contactUsModalReducer from "./../features/contact-us/redux/contactUsModalReducer"
import contactUsReducer from "./../features/contact-us/redux/contactUsReducer"


import gdprModalReducer from "./../features/gdpr/redux/gdprModalReducer"
import gdprReducer from "./../features/gdpr/redux/gdprReducer"


import privacyModalReducer from "./../features/privacy-policy/redux/privacyModalReducer"
import privacyReducer from "./../features/privacy-policy/redux/privacyReducer"
import termsModalReducer from "./../features/terms-and-condition/redux/termsModalReducer"
import termsReducer from "./../features/terms-and-condition/redux/termsReducer"


import paymentOptionModalReducer from "./../features/payment-option/redux/paymentOptionModalReducer"
import paymentOptionReducer from "./../features/payment-option/redux/paymentOptionReducer"


import adReportModalReducer from "./../features/ad-reports/redux/adReportModalReducer"
import adReportReducer from "./../features/ad-reports/redux/adReportUsReducer"

import adminModalReducer from "./../features/admin/redux/adminModalReducer"
import adminReducer from "./../features/admin/redux/adminReducer"
import dealerModalReducer from "./reducers/admin/dealerModalReducer";




import soldAdsModalReducer from "./../features/sold-ads/redux/soldAdsModalReducer"
import soldAdsReducer from "./../features/sold-ads/redux/soldAdsReducer"
import removedExpiredAdsReducer from "./../features/removed-expired-ad/redux/removedExpiredAdsReducer"
import removedExiredAdsModalReducer from "./../features/removed-expired-ad/redux/removedExiredAdsModalReducer"
import dataRequestModalReducer from "../features/data-request/redux/dataRequestModalReducer";
import dataRequestReducer from "../features/data-request/redux/dataRequestReducer";





//Combining the reducer's into a rootReducer
const RootReducer = combineReducers({
    sidebar: showSideBarReducer,
    auth: userReducer,
    userListing: userListingReducer,
    dealerListing: dealerListingReducer,
    dealerModal: dealerModalReducer,
    changePassword: changePasswordReducer,
    newPassword: newPasswordReducer,
    forgotPassword: forgotPasswordReducer,
    changePassModalReducer: changePassModalReducer,
    editProfileModalReducer: editProfileModalReducer,
    editProfile: editProfileReducer,
    userDetails: userDetailsReducer,
    categoryModalReducer,
    categoryReducer,
    attributeModalReducer,
    attributeReducer,
    planModelReducer,
    planReducer,
    bankModalReducer,
    bankReducer,
    adminModalReducer,
    adminReducer,
    vehiclesModelReducer,
    vehiclesReducer,


    suspiciousModelReducer,
    suspiciousReducer,
    financeModelReducer,
    financeReducer,

    settingsModelReducer,
    settingsReducer,
    makeModelReducer,
    makeReducer,
    blogModelReducer,
    blogReducer,
    articleModalReducer,
    articleReducer,
    faqsModalReducer,
    faqsReducer,
    contactUsModalReducer,
    contactUsReducer,
    dataRequestModalReducer,
    dataRequestReducer,

    gdprModalReducer,
    gdprReducer,
    adReportModalReducer,
    adReportReducer,
    privacyModalReducer,
    privacyReducer,

    termsModalReducer,
    termsReducer,



    tierReducer,
    tierModelReducer,



    soldAdsReducer,
    soldAdsModalReducer,


    paymentOptionReducer,
    paymentOptionModalReducer,


    removedExpiredAdsReducer,
    removedExiredAdsModalReducer,

});


export default RootReducer;